import { render, staticRenderFns } from "./Masivo.vue?vue&type=template&id=0506ccc6&"
import script from "./Masivo.vue?vue&type=script&lang=js&"
export * from "./Masivo.vue?vue&type=script&lang=js&"
import style0 from "./Masivo.vue?vue&type=style&index=0&id=0506ccc6&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports